/**
 * HtmlRenderer - Renderiza HTML/CSS/JS puro em sandbox seguro.
 *
 * O script de auto-resize é injetado pelo ArtifactSandbox — não duplicamos aqui.
 * Se o source já é um documento completo (com <html>), retorna como está.
 * Se é um fragmento, envolve em documento mínimo.
 */

export class HtmlRenderer {
    static renderToHtml(source: string): string {
        const isFullDocument =
            /<!doctype/i.test(source) ||
            /<html[\s>]/i.test(source);

        if (isFullDocument) {
            // Se o documento completo não incluiu Tailwind, injeta no <head>
            if (!/cdn\.tailwindcss\.com/i.test(source) && /<head>/i.test(source)) {
                return source.replace(
                    /<head>/i,
                    '<head>\n<script src="https://cdn.tailwindcss.com"></script>'
                );
            }
            return source;
        }

        // Fragmento: envolve em documento completo com Tailwind + reset CSS
        return `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<script src="https://cdn.tailwindcss.com"></script>
<style>
*, *::before, *::after { box-sizing: border-box; }
html, body { margin: 0; padding: 0; font-family: system-ui, -apple-system, 'Segoe UI', sans-serif; }
body { padding: 16px; background: transparent; }
</style>
</head>
<body>
${source}
</body>
</html>`;
    }
}
